/**
 * @generated SignedSource<<3c9605f6a6201d84aba4ba8949897e03>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceRecieversListItemButton_workspaceEntity$data = {
  readonly potentialReceiverStores: ReadonlyArray<{
    readonly __typename: "ReceiverStore";
  }>;
  readonly receiverStores: ReadonlyArray<{
    readonly __typename: "Store";
  }>;
  readonly topic: {
    readonly name: string;
  } | null;
  readonly " $fragmentType": "WorkspaceRecieversListItemButton_workspaceEntity";
};
export type WorkspaceRecieversListItemButton_workspaceEntity$key = {
  readonly " $data"?: WorkspaceRecieversListItemButton_workspaceEntity$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceRecieversListItemButton_workspaceEntity">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceRecieversListItemButton_workspaceEntity",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ReceiverStore",
      "kind": "LinkedField",
      "name": "potentialReceiverStores",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Store",
      "kind": "LinkedField",
      "name": "receiverStores",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OrgTopic",
      "kind": "LinkedField",
      "name": "topic",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WorkspaceEntity",
  "abstractKey": "__isWorkspaceEntity"
};
})();

(node as any).hash = "6f8188e13c519bad36f38d8dda29bd79";

export default node;
